// Will be replaced during production builds - see prepare.sh
// Cast to string so the type stays wide after prepare.sh substitutes the value
// via sed before tsc runs (avoids const literal narrowing).
export const BuildVersion = "b214c23" as string;
